import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import SEO from './SEO';
import Header from './Header';
import { blogPosts } from '../data/blogPosts';
import './BlogList.css';

function BlogList() {
  const [selectedCategory, setSelectedCategory] = useState('all');

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  // Sort posts by date (newest first)
  const sortedPosts = [...blogPosts].sort((a, b) => new Date(b.date) - new Date(a.date));

  // Filter posts by category
  const filteredPosts = selectedCategory === 'all' 
    ? sortedPosts 
    : sortedPosts.filter(post => post.category === selectedCategory);

  // Group posts by category
  const categories = [...new Set(blogPosts.map(post => post.category))];

  return (
    <div className="blog-list-page">
      <SEO 
        title="Acne-Safe Skincare Blog"
        description="Expert guides on acne-safe skincare, non-comedogenic products, and ingredient analysis. Learn how to choose products that won't clog pores."
        keywords="acne safe blog, skincare blog, non-comedogenic products, acne skincare tips, ingredient guides"
        url="https://www.useacnesafe.com/blog"
      />
      <Header />
      
      <div className="blog-container">
        <header className="blog-header">
          <h1>Acne-Safe Skincare Blog</h1>
          <p className="blog-subtitle">Expert guides, product reviews, and tips for clear, acne-free skin</p>
        </header>

        {/* Category Filter */}
        <div className="blog-categories">
          <button 
            className={`category-btn ${selectedCategory === 'all' ? 'active' : ''}`}
            onClick={() => setSelectedCategory('all')}
          >
            All Posts
          </button>
          {categories.map(category => (
            <button 
              key={category} 
              className={`category-btn ${selectedCategory === category ? 'active' : ''}`}
              onClick={() => setSelectedCategory(category)}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Blog Posts Grid */}
        <div className="blog-posts-grid">
          {filteredPosts.map(post => (
            <article key={post.id} className="blog-post-card" data-category={post.category}>
              {post.thumbnail && (
                <Link to={`/blog/${post.slug}`} className="blog-post-image-link">
                  <img 
                    src={post.thumbnail} 
                    alt={post.title}
                    className="blog-post-thumbnail"
                    loading="lazy"
                  />
                </Link>
              )}
              <div className="blog-post-meta">
                <span className="blog-category">{post.category}</span>
                <span className="blog-date">{new Date(`${post.date}T12:00:00`).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</span>
              </div>
              <h2 className="blog-post-title">
                <Link to={`/blog/${post.slug}`}>{post.title}</Link>
              </h2>
              <p className="blog-post-excerpt">{post.description}</p>
              <Link to={`/blog/${post.slug}`} className="blog-read-more">
                Read More →
              </Link>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
}

export default BlogList;

